import React from 'react';

import EditionsIcon from '@atlaskit/icon-lab/core/editions';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import Tooltip from '@atlaskit/tooltip';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';

import messages from '../messages.tsx';

export const PaidFeatureAwarenessGemIcon = ({
	edition = 'premium',
	tooltipContent: customTooltipContent,
}: {
	edition?: 'standard' | 'premium';
	tooltipContent?: string;
}) => {
	const { formatMessage } = useIntl();

	const tooltipContent =
		customTooltipContent ||
		(edition === 'premium'
			? formatMessage(messages.premiumTooltip)
			: formatMessage(messages.standardGemTooltip));

	return (
		<Tooltip content={tooltipContent}>
			<EditionsIcon label="" color={token('color.icon.discovery')} />
		</Tooltip>
	);
};

export const PaidFeatureAwarenessInfoIcon = ({
	tooltipContent: customTooltipContent,
}: {
	tooltipContent?: string;
}) => {
	const { formatMessage } = useIntl();

	const tooltipContent = customTooltipContent || formatMessage(messages.automationTooltip);

	return (
		<Tooltip content={tooltipContent}>
			<InformationCircleIcon label={tooltipContent} color={token('color.icon.discovery')} />
		</Tooltip>
	);
};
